import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { JitsiTrackEvents } from '../../../base/lib-jitsi-meet';
import { trackStreamingStatusChanged } from '../../../base/tracks/actions.web';
import { PARTICIPANT_ROLE } from '../../../base/participants/constants';
const useStyles = makeStyles()(() => {
    return {};
});
export const ConnectionIndicatorIcon = ({ classes, colorClass, connectionIndicatorInactiveDisabled, isConnectionStatusInactive, isConnectionStatusInterrupted, track, localParticipant }) => {
    const { cx } = useStyles();
    const dispatch = useDispatch();
    const sourceName = track?.jitsiTrack?.getSourceName();
    const handleTrackStreamingStatusChanged = (jitsiTrack, streamingStatus) => {
        dispatch(trackStreamingStatusChanged(jitsiTrack, streamingStatus));
    };
    // TODO: replace this with a custom hook to be reused where track streaming status is needed.
    // TODO: In the hood the listener should updates a local track streaming status instead of that in redux store.
    useEffect(() => {
        if (track && !track.local) {
            track.jitsiTrack.on(JitsiTrackEvents.TRACK_STREAMING_STATUS_CHANGED, handleTrackStreamingStatusChanged);
            dispatch(trackStreamingStatusChanged(track.jitsiTrack, track.jitsiTrack.getTrackStreamingStatus?.()));
        }
        return () => {
            if (track && !track.local) {
                track.jitsiTrack.off(JitsiTrackEvents.TRACK_STREAMING_STATUS_CHANGED, handleTrackStreamingStatusChanged);
                dispatch(trackStreamingStatusChanged(track.jitsiTrack, track.jitsiTrack.getTrackStreamingStatus?.()));
            }
        };
    }, [sourceName]);
    if (isConnectionStatusInactive) {
        if (connectionIndicatorInactiveDisabled) {
            return null;
        }
        return (React.createElement("span", { className: 'connection_ninja' },
            React.createElement("div", { className: cx(classes.icon, colorClass) }, "Video is lost")));
    }
    let emptyIconWrapperClassName = 'connection_empty';
    if (isConnectionStatusInterrupted) {
        // emptyIconWrapperClassName is used by the torture tests to identify lost connection status handling.
        emptyIconWrapperClassName = 'connection_lost';
    }
    function getSignerVideoQualityString(colorClass) {
        if (colorClass === 'status-high') {
            return 'Video quality good';
        }
        else if (colorClass === 'status-med') {
            return 'Video quality fair';
        }
        else if (colorClass === 'status-low') {
            return 'Video quality poor';
        }
        else {
            return 'Video is lost';
        }
    }
    // display signer video quality for moderator only
    return (React.createElement("span", { className: emptyIconWrapperClassName }, localParticipant?.role === PARTICIPANT_ROLE.MODERATOR && (React.createElement("div", { className: cx(classes.icon, colorClass) }, getSignerVideoQualityString(colorClass)))));
};
